"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWhatsappStaffTemplate = getWhatsappStaffTemplate;
exports.renderWhatsappStaffTemplate = renderWhatsappStaffTemplate;
exports.isWhatsappServiceWindowOpen = isWhatsappServiceWindowOpen;
function getWhatsappStaffTemplate(template) {
    if (template.status !== 'APPROVED')
        return null;
    const allowedTypes = new Set(['BODY', 'FOOTER', 'BUTTONS']);
    const types = template.components.map(({ type }) => type);
    if (new Set(types).size !== types.length || types.some((type) => !allowedTypes.has(type)))
        return null;
    const body = template.components.find(({ type }) => type === 'BODY')?.text;
    const footer = template.components.find(({ type }) => type === 'FOOTER')?.text ?? '';
    if (!body?.trim() || footer.includes('{{'))
        return null;
    const variables = [...body.matchAll(/\{\{([^}]+)\}\}/g)].map((match) => match[1]);
    const indexes = [...new Set(variables.map(Number))].sort((a, b) => a - b);
    if (indexes.length > 20 || variables.some((value) => !/^[1-9]\d*$/.test(value))
        || indexes.some((value, index) => value !== index + 1))
        return null;
    const buttonComponent = template.components.find(({ type }) => type === 'BUTTONS');
    const buttons = buttonComponent?.buttons ?? [];
    // Automation quick replies carry action-specific payloads. Only the recovery
    // template has a plain conversation reply that is safe for manual sending.
    if (buttonComponent && (template.name !== 'conversation_reopen_24h'
        || buttons.length !== 1 || buttons.some((button) => button.type !== 'QUICK_REPLY' || !button.text?.trim())))
        return null;
    return { body, footer, parameterCount: indexes.length, buttonTexts: buttons.map((button) => button.text) };
}
function renderWhatsappStaffTemplate(body, parameters) {
    return body.replace(/\{\{(\d+)\}\}/g, (placeholder, index) => parameters[Number(index) - 1] ?? placeholder);
}
function isWhatsappServiceWindowOpen(expiresAt, now = Date.now()) {
    return Boolean(expiresAt && Date.parse(expiresAt) > now);
}
